import { FC } from "react";
import { theme } from "tailwind.config";
import IconAddFill from "@/assets/imgs/svg/icon-add-fill.svg";
import useBtnRequiresIsDesigner from "@/features/user/hooks/useBtnRequiresDesigner";
import { useRouter } from "next/router";

const ProjectItemForCreate: FC = () => {
  const router = useRouter();
  const { clickHandler } = useBtnRequiresIsDesigner(() => {
    router.push("/projects/new");
  });

  return (
    <button
      className="relative rounded-xs border-primary border-dashed border-2 hover:bg-gray-100 min-h-[240px]"
      onClick={clickHandler}
    >
      <div className="absolute top-1/2 left-1/2 tranform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-8 pointer-events-none">
        <IconAddFill width={48} height={48} fill={theme.colors.yellow[500]} />
        <p className="font-bold text-sm laptop:text-base whitespace-nowrap">
          プロジェクトを作成する
        </p>
      </div>
    </button>
  );
};

export default ProjectItemForCreate;
